import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';

import { Help } from '@model';
import { SxErrorService } from 'app/services/sx-error.service';

@Injectable({
  providedIn: 'root'
})
export class HelpService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getHelp(): Observable<Help> {
    return this.http
      .get<Help>(`${environment.apiEndpoint}/Help`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
